import { FormApiMethodsRequestData } from '../../../api/types/types';
import {
  FormTokenNode,
  ResponseActionHandler,
} from '../../../types/context';
import useApiErrorHandling from '../../../hooks/useApiErrorHandling';
import { resolveFormApiMethod } from './resolveFormApiMethod';
import { Form } from '../../../types/types';
import { submitWithForceRetry } from './submitWithForceRetry';

// Submits form data for insert (create-item) mode
export const submitInsertForm = async (
  form: Form,
  requestBody: Record<string, unknown>,
  actualToken: FormTokenNode | null,
  sessionToken: string | null,
  insert: (api: string, data: any) => Promise<any>,
  handleApiError: ReturnType<typeof useApiErrorHandling>,
  getResponseActionHandler?: (name: string) => ResponseActionHandler | undefined
) => {
  const resolvedMethod = resolveFormApiMethod(form.apiMethods, 'create-item');

  if (!resolvedMethod) {
    throw new Error('No method found');
  }

  // String apiMethod — insert hook handles error internally
  if (typeof resolvedMethod === 'string') {
    return await insert(resolvedMethod, requestBody);
  }

  // DetailedApiMethod flow with error handling and forceHeader retry
  const tokenRequestData = actualToken?.meta
    ?.requestData as FormApiMethodsRequestData;
  const submitRequestData: FormApiMethodsRequestData = {
    ...tokenRequestData,
    sessionId: sessionToken ?? '',
    form: requestBody,
  };

  return submitWithForceRetry(
    resolvedMethod,
    submitRequestData,
    handleApiError,
    getResponseActionHandler
  );
};
